export default "__VITE_ASSET__PDtMvrn2__"